(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["jj-cart-addons"]) return;
  try {
    
(() => {
  const normalise = value => String(value || '').toLowerCase().replace(/[^a-z0-9]/g, '');
  function recommendations(cart, products) {
    const items = cart.items || [];
    if (!items.some(item => item.requires_shipping) || items.some(item =>
      /bundle|collection|starter kit|mystery|advent|subscription|\bedit\b/i.test(item.product_title + ' ' + item.product_type) ||
      item.item_components?.length || item.parent_relationship || item.selling_plan_allocation ||
      Object.entries(item.properties || {}).some(([key, value]) => /part of|bundle/i.test(key + ' ' + value)))) return [];
    const existing = new Set(items.map(item => String(item.product_id)));
    const binders = items.filter(item => /binder|planner pad/i.test(item.product_title || ''));
    return products.flatMap(product => {
      if (existing.has(String(product.id)) || !product.variants.length) return [];
      if (product.colourMatch) {
        const variant = product.variants.find(option => binders.some(item => normalise(item.variant_title).includes(normalise(option.title))));
        return variant ? [{ product, variant, matched: true }] : [];
      }
      return [{ product, variant: product.variants.length === 1 ? product.variants[0] : null, matched: false }];
    }).sort((a, b) => Number(b.matched) - Number(a.matched)).slice(0, 2);
  }

  function start() {
    const configNode = document.querySelector('[data-jj-addons-config]');
    const template = document.getElementById('jj-addons-panel-template');
    if (!configNode || !template || configNode.dataset.started) return;
    configNode.dataset.started = 'true';
    const config = JSON.parse(configNode.textContent);
    const panels = new Map();
    const subscribers = new Set();
    let cart = null;
    let request = null;
    let timer;
    let adding = false;
    let queuedRefresh = false;
    let rootObserver;
    let observedRoot;
    const money = price => new Intl.NumberFormat(document.documentElement.lang || 'en-GB', { style: 'currency', currency: config.currency }).format(price / 100);
    const make = (tag, className, text) => {
      const node = document.createElement(tag);
      if (className) node.className = className;
      if (text !== undefined) node.textContent = text;
      return node;
    };
    async function getCart() {
      const response = await fetch(config.root + 'cart.js', { credentials: 'same-origin', cache: 'no-store' });
      if (!response.ok) throw new Error(config.strings.error);
      return response.json();
    }
    function drawerRoot() {
      const element = document.getElementById('upCart');
      return element?.shadowRoot || element;
    }
    function mount(context, anchor, before) {
      if (!anchor) return;
      let panel = panels.get(context);
      if (!panel) {
        panel = document.createElement('jj-cart-addons');
        panel.dataset.context = context;
        panel.hidden = true;
        panel.attachShadow({ mode: 'open' }).append(template.content.cloneNode(true));
        panel.shadowRoot.querySelector('h2').textContent = config.strings.heading;
        panel.shadowRoot.querySelector('.intro').textContent = config.strings.intro;
        panels.set(context, panel);
      }
      if (!panel.isConnected) {
        if (before) anchor.before(panel);
        else anchor.after(panel);
      }
    }
    function mountPanels() {
      const root = drawerRoot();
      const items = root?.querySelector('.upcart-public-cart-items');
      mount('drawer', items, false);
      mount('page', document.querySelector('form.cart-page .cart-footer'), true);
      if (root && observedRoot !== root) {
        rootObserver?.disconnect();
        observedRoot = root;
        rootObserver = new MutationObserver(records => {
          if (records.some(record => Array.from(record.addedNodes).concat(Array.from(record.removedNodes)).some(node => node.nodeType === 1 && node.tagName !== 'JJ-CART-ADDONS'))) {
            mountPanels();
            if (cart) render();
          }
        });
        rootObserver.observe(root, { childList: true, subtree: true });
      }
    }
    function render() {
      if (!cart || adding) return;
      const choices = recommendations(cart, config.products);
      for (const [context, panel] of panels) {
        if (!panel.isConnected) continue;
        const fingerprint = JSON.stringify(choices.map(choice => [choice.product.id, choice.variant?.id, choice.product.variants.map(variant => variant.id)]));
        panel.hidden = choices.length === 0;
        if (panel.dataset.fingerprint === fingerprint) continue;
        panel.dataset.fingerprint = fingerprint;
        const list = panel.shadowRoot.querySelector('.cards');
        list.replaceChildren();
        for (const choice of choices) {
          const { product, matched } = choice;
          let selected = choice.variant;
          const card = make('article');
          const pictureLink = make('a');
          pictureLink.href = product.url;
          pictureLink.tabIndex = -1;
          pictureLink.setAttribute('aria-hidden', 'true');
          const img = make('img');
          img.alt = '';
          img.width = 64;
          img.height = 64;
          img.loading = 'lazy';
          img.src = selected?.image || product.image;
          pictureLink.append(img);
          const details = make('div', 'details');
          const title = make('h3');
          const link = make('a', '', product.title);
          link.href = product.url + (selected ? '?variant=' + selected.id : '');
          title.append(link);
          details.append(title);
          const controls = make('div', 'controls');
          const price = make('span', 'price', money((selected || product.variants[0]).price));
          const button = make('button', '', config.strings.add);
          button.type = 'button';
          const update = () => {
            button.disabled = !selected;
            button.setAttribute('aria-label', config.strings.add + ' ' + product.title + (selected && selected.title !== 'Default Title' ? ' — ' + selected.title : ''));
            if (selected) {
              price.textContent = money(selected.price);
              img.src = selected.image || product.image;
              link.href = product.url + '?variant=' + selected.id;
              pictureLink.href = link.href;
            }
          };
          if (matched) details.append(make('p', 'match', config.strings.match), make('p', 'variant', selected.title));
          else if (product.variants.length > 1) {
            const select = make('select');
            select.setAttribute('aria-label', config.strings.choose + ' — ' + product.title);
            const placeholder = make('option', '', config.strings.choose);
            placeholder.value = '';
            select.append(placeholder);
            product.variants.forEach(variant => {
              const option = make('option', '', variant.title + ' — ' + money(variant.price));
              option.value = String(variant.id);
              select.append(option);
            });
            select.addEventListener('change', () => {
              selected = product.variants.find(variant => String(variant.id) === select.value);
              update();
            });
            details.append(select);
          } else if (selected.title !== 'Default Title') details.append(make('p', 'variant', selected.title));
          controls.append(price, button);
          details.append(controls);
          card.append(pictureLink, details);
          list.append(card);
          update();
          button.addEventListener('click', async event => {
            event.preventDefault();
            event.stopPropagation();
            if (!selected || adding) return;
            adding = true;
            button.disabled = true;
            button.textContent = config.strings.adding;
            const status = panel.shadowRoot.querySelector('.status');
            status.replaceChildren();
            let succeeded = false;
            try {
              const latest = await getCart();
              if (!recommendations(latest, config.products).some(choice => choice.product.id === product.id)) {
                cart = latest;
                return;
              }
              const response = await fetch(config.root + 'cart/add.js', {
                method: 'POST', credentials: 'same-origin',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ items: [{ id: selected.id, quantity: 1, properties: { _jj_cart_addon: 'matching-accessories-v1' } }] })
              });
              if (!response.ok) {
                if (response.status === 422) product.variants = product.variants.filter(variant => variant.id !== selected.id);
                throw new Error(config.strings.error);
              }
              succeeded = true;
              status.textContent = config.strings.added;
              if (context === 'page' || typeof window.upcartRefreshCart !== 'function') {
                window.location.assign(config.cartUrl);
                return;
              }
              await window.upcartRefreshCart();
              cart = await getCart();
              document.dispatchEvent(new CustomEvent('cart:refresh'));
            } catch (error) {
              status.textContent = succeeded ? config.strings.refresh : config.strings.error;
              if (succeeded) {
                const retry = make('a', 'retry', config.strings.refresh);
                retry.href = config.cartUrl;
                status.append(document.createElement('br'), retry);
                product.variants = [];
              }
            } finally {
              adding = false;
              button.textContent = config.strings.add;
              button.disabled = succeeded;
              render();
              if (queuedRefresh) { queuedRefresh = false; schedule(); }
            }
          });
        }
      }
    }
    async function refresh() {
      if (adding) { queuedRefresh = true; return; }
      if (request) { queuedRefresh = true; return; }
      request = getCart();
      try {
        cart = await request;
        mountPanels();
        render();
      } catch (error) {
        panels.forEach(panel => { panel.hidden = true; });
      } finally {
        request = null;
        if (queuedRefresh) { queuedRefresh = false; schedule(); }
      }
    }
    function schedule() {
      clearTimeout(timer);
      timer = setTimeout(refresh, 120);
    }
    function connect() {
      ['upcartSubscribeCartLoaded', 'upcartSubscribeCartOpened', 'upcartSubscribeCartUpdated'].forEach(name => {
        if (!subscribers.has(name) && typeof window[name] === 'function') {
          window[name](schedule);
          subscribers.add(name);
        }
      });
      mountPanels();
    }
    connect();
    let attempts = 0;
    const connectionTimer = setInterval(() => {
      connect();
      if (subscribers.size === 3 || ++attempts >= 40) clearInterval(connectionTimer);
    }, 250);
    document.addEventListener('cart:change', schedule);
    document.addEventListener('cart:refresh', schedule);
    document.addEventListener('click', event => {
      if (event.target.closest('a[href$="/cart"],button[aria-controls="cart-drawer"]')) { connect(); schedule(); }
    }, { passive: true });
    window.addEventListener('pageshow', schedule);
    if (document.querySelector('form.cart-page') || drawerRoot()) schedule();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
  document.addEventListener('shopify:section:load', start);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jj-cfk-basket"]) return;
  try {
    
(() => {
  function start() {
    const configNode = document.querySelector('[data-jj-cfk-basket-config]');
    const template = document.getElementById('jj-cfk-basket-template');
    if (!configNode || !template || configNode.dataset.started) return;
    configNode.dataset.started = 'true';
    const config = JSON.parse(configNode.textContent);
    if (!config.pin.available && !config.presets.length && !config.unit.available) return;
    const strings = config.strings;
    const money = price => new Intl.NumberFormat(document.documentElement.lang || 'en-GB', { style: 'currency', currency: config.currency }).format(price / 100);
    const panels = new Map();
    const subscribers = new Set();
    const storageKey = 'jj-cfk-basket-dismissed-v1';
    let dismissed = false;
    try { dismissed = sessionStorage.getItem(storageKey) === 'yes'; } catch {}
    let cart;
    let busy = false;
    let uncertain = false;
    let refreshing = false;
    let refreshAgain = false;
    let refreshTimer;
    let observedRoot;
    let observer;
    const state = { choice: 'none', amount: '', custom: '' };
    const getRoot = () => { const element = document.getElementById('upCart'); return element?.shadowRoot || element; };
    const inCart = id => cart?.items?.some(item => String(item.product_id) === String(id) && item.quantity > 0);
    async function getCart() {
      const response = await fetch(config.root.replace(/\/?$/, '/') + 'cart.js', { credentials: 'same-origin', cache: 'no-store' });
      if (!response.ok) throw new Error(strings.error);
      return response.json();
    }
    function selection() {
      if (state.choice === 'pin') return config.pin.available && !inCart(config.pin.productId) ? { id: config.pin.id, quantity: 1, price: config.pin.price } : null;
      if (state.choice !== 'donation' || inCart(config.donationProductId)) return null;
      if (state.amount === 'custom') {
        const quantity = Number(state.custom);
        return config.unit.available && /^\d+$/.test(state.custom) && Number.isSafeInteger(quantity) && quantity >= 1 && quantity <= config.unit.maximum ? { id: config.unit.id, quantity, price: quantity * 100 } : null;
      }
      const variant = config.presets.find(preset => String(preset.id) === state.amount);
      return variant ? { ...variant, quantity: 1 } : null;
    }
    function render() {
      const hasPin = inCart(config.pin.productId);
      const hasDonation = inCart(config.donationProductId);
      if ((state.choice === 'pin' && hasPin) || (state.choice === 'donation' && hasDonation)) state.choice = 'none';
      const selected = selection();
      for (const panel of panels.values()) {
        panel.hidden = !cart?.item_count;
        const root = panel.shadowRoot;
        root.querySelector('section').hidden = dismissed;
        root.querySelector('.reopen').hidden = !dismissed;
        panel.setAttribute('aria-busy', String(busy));
        const pin = root.querySelector('[data-choice="pin"]');
        pin.textContent = hasPin ? strings.pin_present : strings.pin + ' · ' + money(config.pin.price);
        pin.hidden = !config.pin.available && !hasPin;
        pin.disabled = busy || uncertain || hasPin;
        const donation = root.querySelector('[data-choice="donation"]');
        donation.textContent = hasDonation ? strings.donation_present : hasPin ? strings.donate_extra : strings.donate;
        donation.hidden = !config.presets.length && !config.unit.available && !hasDonation;
        donation.disabled = busy || uncertain || hasDonation;
        root.querySelector('[data-choice="none"]').disabled = busy;
        root.querySelectorAll('[data-choice]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.choice === state.choice)));
        root.querySelector('.details').hidden = state.choice === 'none' || uncertain;
        root.querySelector('.note').hidden = state.choice !== 'pin' || !strings.preorder;
        root.querySelector('.donation').hidden = state.choice !== 'donation';
        root.querySelectorAll('[data-amount]').forEach(button => { button.setAttribute('aria-pressed', String(button.dataset.amount === state.amount)); button.disabled = busy || uncertain; });
        root.querySelector('.custom').hidden = state.amount !== 'custom';
        const input = root.querySelector('input');
        input.disabled = busy || uncertain || state.amount !== 'custom';
        if (input.value !== state.custom) input.value = state.custom;
        const invalid = state.choice === 'donation' && state.amount === 'custom' && state.custom !== '' && !selected;
        input.setAttribute('aria-invalid', String(invalid));
        const error = root.querySelector('.error');
        error.hidden = !invalid && !uncertain;
        error.textContent = uncertain ? strings.error : strings.invalid;
        const add = root.querySelector('.add');
        add.disabled = busy || uncertain || !selected;
        add.textContent = busy ? strings.adding : (state.choice === 'pin' ? strings.pin : strings.add_donation) + (selected ? ' · ' + money(selected.price) : '');
        const status = root.querySelector('.status');
        status.hidden = !hasPin && !hasDonation;
        status.textContent = hasPin && hasDonation ? strings.thanks_both : hasPin ? strings.thanks_pin : strings.thanks_donation;
        root.querySelector('.view-cart').hidden = !uncertain;
      }
    }
    function createPanel(context) {
      const panel = document.createElement('jj-cfk-basket');
      panel.hidden = true;
      panel.dataset.context = context;
      const root = panel.attachShadow({ mode: 'open' });
      root.append(template.content.cloneNode(true));
      root.querySelector('section').setAttribute('aria-label', strings.heading);
      root.querySelector('.caption').textContent = strings.caption;
      root.querySelector('h2').textContent = strings.heading;
      root.querySelector('.intro').textContent = strings.intro;
      root.querySelector('.choices').setAttribute('aria-label', strings.heading);
      root.querySelector('[data-choice="none"]').textContent = strings.decline;
      root.querySelector('.reopen').textContent = strings.reopen;
      root.querySelector('.note').textContent = strings.preorder;
      root.querySelector('.donation > .amount-label').textContent = strings.choose;
      root.querySelector('.amounts').setAttribute('aria-label', strings.choose);
      root.querySelector('.custom label').textContent = strings.custom;
      root.querySelector('input').max = String(config.unit.maximum);
      const link = root.querySelector('.view-cart');
      link.href = config.cartUrl;
      link.textContent = strings.view_cart;
      const amounts = root.querySelector('.amounts');
      const addAmount = (id, label) => {
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'amount';
        button.dataset.amount = String(id);
        button.textContent = label;
        button.setAttribute('aria-pressed', 'false');
        amounts.append(button);
      };
      config.presets.forEach(preset => addAmount(preset.id, money(preset.price)));
      if (config.unit.available) addAmount('custom', strings.other);
      root.addEventListener('click', event => {
        const button = event.target.closest('button');
        if (!button || button.disabled) return;
        event.preventDefault();
        event.stopPropagation();
        if (button.matches('.add')) { submit(context); return; }
        if (button.matches('.reopen')) {
          dismissed = false;
          try { sessionStorage.removeItem(storageKey); } catch {}
        } else if (button.dataset.choice) {
          state.choice = button.dataset.choice;
          if (state.choice === 'none') {
            dismissed = true;
            try { sessionStorage.setItem(storageKey, 'yes'); } catch {}
          }
        } else if (button.dataset.amount) state.amount = button.dataset.amount;
        render();
        if (button.dataset.amount === 'custom') root.querySelector('input').focus();
        if (dismissed) root.querySelector('.reopen').focus();
      });
      root.querySelector('input').addEventListener('input', event => { state.custom = event.target.value.trim(); render(); });
      root.querySelector('input').addEventListener('keydown', event => { if (event.key === 'Enter') { event.preventDefault(); if (selection()) submit(context); } });
      panels.set(context, panel);
      return panel;
    }
    function mount(context, anchor) {
      if (!anchor) return;
      const panel = panels.get(context) || createPanel(context);
      if (anchor.previousElementSibling !== panel) anchor.before(panel);
    }
    function mountPanels() {
      const root = getRoot();
      mount('drawer', root?.querySelector('.upcart-checkout-button-container'));
      mount('page', document.querySelector('form.cart-page .cart-recap [name="checkout"]'));
      if (!root) mount('native', document.querySelector('#cart-drawer .button-group'));
      if (root && root !== observedRoot) {
        observer?.disconnect();
        observedRoot = root;
        observer = new MutationObserver(() => { mountPanels(); render(); });
        observer.observe(root, { childList: true, subtree: true });
      }
    }
    async function refresh() {
      if (busy || refreshing) { refreshAgain = true; return; }
      refreshing = true;
      try { cart = await getCart(); mountPanels(); render(); }
      catch { if (!cart) panels.forEach(panel => { panel.hidden = true; }); }
      finally { refreshing = false; if (refreshAgain) { refreshAgain = false; schedule(); } }
    }
    function schedule() { clearTimeout(refreshTimer); refreshTimer = setTimeout(refresh, 120); }
    async function submit(context) {
      if (busy || uncertain || !selection()) return;
      const chosen = { ...selection() };
      const chosenType = state.choice;
      busy = true;
      render();
      try {
        cart = await getCart();
        if (inCart(chosenType === 'pin' ? config.pin.productId : config.donationProductId)) return;
        const properties = chosenType === 'donation' ? { _jj_charity_donation: 'true', _jj_cfk_basket: 'v1' } : { _jj_cfk_basket: 'v1' };
        const response = await fetch(config.root.replace(/\/?$/, '/') + 'cart/add.js', {
          method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [{ id: chosen.id, quantity: chosen.quantity, properties }] })
        });
        if (!response.ok) throw new Error(strings.error);
        await response.json();
        cart = await getCart();
        state.choice = 'none';
        if (context === 'drawer' && typeof window.upcartRefreshCart === 'function') {
          await window.upcartRefreshCart();
          document.dispatchEvent(new CustomEvent('cart:refresh'));
        } else {
          window.location.assign(config.cartUrl);
        }
      } catch {
        uncertain = true;
        try { cart = await getCart(); } catch {}
      } finally {
        busy = false;
        mountPanels();
        render();
        if (refreshAgain) { refreshAgain = false; schedule(); }
      }
    }
    function connect() {
      ['upcartSubscribeCartLoaded', 'upcartSubscribeCartOpened', 'upcartSubscribeCartUpdated'].forEach(name => {
        if (!subscribers.has(name) && typeof window[name] === 'function') { window[name](schedule); subscribers.add(name); }
      });
      mountPanels();
    }
    connect();
    let attempts = 0;
    const timer = setInterval(() => { connect(); if (subscribers.size === 3 || ++attempts >= 40) clearInterval(timer); }, 250);
    document.addEventListener('cart:change', schedule);
    document.addEventListener('cart:refresh', schedule);
    document.addEventListener('click', event => { if (event.target.closest('a[href$="/cart"],button[aria-controls="cart-drawer"]')) { connect(); schedule(); } }, { passive: true });
    window.addEventListener('pageshow', schedule);
    schedule();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
  document.addEventListener('shopify:section:load', start);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jj-cfk-support"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('jj-cfk-donation')) {
  customElements.define('jj-cfk-donation', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const form = this.querySelector('form');
      if (!form) return;
      form.addEventListener('submit', async event => {
        event.preventDefault();
        event.stopImmediatePropagation();
        if (this.busy || !form.reportValidity()) return;
        const choice = form.querySelector('input[name="id"]:checked:not(:disabled)');
        if (!choice) return;
        const button = form.querySelector('button[type="submit"]');
        const error = this.querySelector('[role="alert"]');
        const label = button.textContent;
        this.busy = true;
        button.disabled = true;
        button.textContent = this.dataset.adding;
        error.hidden = true;
        try {
          const response = await fetch(this.dataset.addUrl, {
            method: 'POST', credentials: 'same-origin',
            headers: {'Content-Type': 'application/json', 'Accept': 'application/json'},
            body: JSON.stringify({items: [{id: choice.value, quantity: 1, properties: {_jj_charity_donation: 'true'}}]}),
            signal: AbortSignal.timeout(15000)
          });
          if (!response.ok) throw new Error('Donation not confirmed');
          const result = await response.json();
          if (!Array.isArray(result.items) || result.items.length !== 1) throw new Error('Donation not confirmed');
          window.location.assign(this.dataset.cartUrl);
        } catch {
          error.textContent = this.dataset.error;
          error.hidden = false;
          this.busy = false;
          button.disabled = false;
          button.textContent = label;
        }
      }, {capture: true, signal: this.controller.signal});
    }
    disconnectedCallback() { this.controller?.abort(); }
  });
}

  } catch(e) { console.error(e); }
})();
})();
